export default "__VITE_ASSET__BlirLa$6__"